<template>
    <div>
        <div class="footer">
            <div class="footer_border_bg"><img src="@/assets/images/footer_border.jpg" /> </div>
            <div class="main">
                <div class="footer_link_title">友情链接</div>
                <div class="link_content flex_center flex_wrap">
                    <a :href="item.url" v-for="(item,index) in link" target="_blank">{{item.name}}</a>
                </div>
            </div>
            <div class="foot" v-html="copy_right">
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        // name: "footer",
        data () {
            return {
                link:'',
                copy_right:''
            }
        },
        created: function() {
            this.$http({
                url: 'index/getFooter',
                method: 'post',
                headers: { "Content-Type": "multipart/form-data" },
            }).then(res => {
                this.link = res.data.data.link;
                this.copy_right = res.data.data.copy_right;
            });
        },
        methods: {
        }
    }
</script>

<style>
    .footer{width: 100%;position: relative;background: #eee;}
    .footer_border_bg{width: 100%;height: 7px;position: absolute;top:0;left:0;}
    .footer_border_bg img{width:100%;height: 7px;background-size: cover;display: block;}
    .footer_link_title{width: 100%;text-align: center;color:#c1000e;font-size:20px;line-height: 20px;padding:37px 0 20px;font-weight: bold;}
    .link_content{width:96%;max-width:500px;text-align: center;margin:0 auto;}
    .link_content a{font-size: 14px;line-height: 15px;margin:8px 0;padding:0 20px;border-right:1px solid #856a8b;width:auto;color:#666;}
    .link_content a:last-child{border:none;display: block;}
    .foot{width:96%;max-width:805px;margin:25px auto 0;display: block;border-top:1px solid #dcdcdc;padding-top:20px;text-align: center;color:#666;font-size:14px;line-height: 28px;padding-bottom: 35px;}
    .foot a{color:#666;display: inline-block;white-space: nowrap;}
    .foot img{max-height: 20px;display: inline-block;margin-right: 5px;vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue